import { TimelineSection } from '../section-listing.model';

/**
 * A LEAP v2 (LearnerJourney) session as a read-only timeline section (sectionType 'session').
 * Shaped on the add-session-v2 model (LeapV2Session / LeapV2StudentProgress) for the timeline's single
 * student: session meta + attendance, the objectives with this student's attainment, one engagement
 * rating, and the two progress comments. Serialised by the backend LeapV2SessionSection; links to the
 * full session report screen.
 */
export class LeapV2SessionTimelineSection extends TimelineSection {
  studentId: number;

  /**
   * Orbit BookingSessions.Id — the exact session this card addresses. The click-through to the
   * session report screen navigates on this (SessionIdentityGrain.md), not just a date.
   */
  orbitSessionId: number;

  statusId?: number;
  submitted: boolean;
  approved: boolean;

  attendance: string;
  /** Attendance reason and comments, recorded when the student was not Present. */
  reason: string;
  reasonDescription: string;

  sessionType: string;
  sessionDelivery: string;
  startTime: string;
  endTime: string;
  tutorId: number;

  /**
   * Learning objectives with this student's attainment level (0-based, -1 = not set). Built by the
   * backend from ObjectivesJson/AttainmentLevelsJson; legacy sessions are folded into the same shape.
   */
  objectives?: TimelineObjective[];

  /** Engagement rating 1–5; absent when not set. */
  engagementRating?: number;

  /** add-session-v2 `objectiveComments` (backend column LearningComment). */
  learningComment: string;
  /** add-session-v2 `engagementComments` (backend column EngagementComment). */
  engagementComment: string;

  /** Evidence of work uploaded to this session: name and read-only blob link. Absent on a learner's own view. */
  evidence?: { name: string; url: string }[];
}

/** One objective on the card: its text plus the student's attainment level (0-based, -1 = not set). */
export interface TimelineObjective {
  text: string;
  attainmentLevel: number;
}
